import { Intent } from '@applyboard/crystal-ui/lib/types/design'

import { DecisionResponseType } from '@applyboard/school-applications-types-lib/dist/src/backend/applications-api/resources/applications/student-decisions'

export function getTagInformation(
  status: DecisionResponseType | string | undefined,
  activeRecord?: boolean,
): {
  label: string
  intent: Intent
} {
  if (!activeRecord && status === 'Invalid') {
    return {
      label: 'Invalid',
      intent: 'secondary',
    }
  } else {
    switch (status) {
      case 'ACCEPTED':
        return {
          label: 'Accepted',
          intent: 'positive',
        }
      case 'REJECTED':
        return {
          label: 'Rejected',
          intent: 'negative',
        }
      case 'PENDING':
      default:
        return {
          label: 'Pending',
          intent: 'warning',
        }
    }
  }
}
